export default {
  title: 'Palveluntarjoajasi hoitaa tämän vaiheen',
  description: {
    payments: 'Ota yhteyttä {{partner}}iin verkkomaksujen käyttöönottamiseksi.',
    go_live: 'Ota yhteyttä {{partner}}iin ravintolasi julkaisemiseksi.',
  },
  fallback_partner: 'palveluntarjoajaasi',
};
